import i18n from 'i18next';

export function toAcceptLanguage(language: string | undefined): string {
  switch (language?.split('-')[0]?.toLowerCase()) {
    case 'no':
    case 'nb':
    case 'nn':
      return 'nb';
    case 'se':
    case 'sv':
      return 'sv';
    case 'en':
      return 'en';
    default:
      return 'nb';
  }
}

export function getAcceptLanguage(): string {
  return toAcceptLanguage(i18n.language);
}
